import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask1600To1699Service {

  constructor() { }
}
